/**
 * Comfort Footworks PDP (sections/main-product-custom.liquid).
 * Rebuilt 2026-09-16 (Claude, PDP agent).
 *
 * - Option pills (colour / size / width / other) by event delegation.
 *   Size and width start unselected unless ?variant= named one.
 * - The ATC label is always "Add to cart · $149". Tapping it with a missing
 *   choice scrolls to that picker, focuses its first button and inserts
 *   <p class="pdp__size-error" role="alert">Please choose your size first.</p>
 * - Add to cart POSTs /cart/add.js (JSON), fetches /cart.js, then dispatches
 *   `cfw:cart:added` {item, items, cart} (contract #3) plus Horizon's
 *   `cart:update`. Button reads "Added ✓" for 2s. If no drawer
 *   (window.CFW.openCartDrawer) exists 300ms later, go to /cart.
 * - Vendor + price aware ship line; installment amount; ?variant= sync.
 * - Colour change filters the desktop grid and the mobile carousel.
 * - Optional orthotic add-on (contract #4, degrades to hidden).
 * - Public API: window.cfwVariantPicker.selectOption(i, value),
 *   window.cfwPdp.{getState, addToCart, showRequiredError}, event
 *   `cfw:pdp:state` on document whenever the selection changes.
 */
(function () {
  'use strict';

  var pd = window.productData;
  if (!pd || !pd.variants || !pd.variants.length) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var form = document.getElementById('product-form');
  var idInput = document.getElementById('product-variant-id');
  var atc = document.getElementById('pdp-add-to-cart');
  var atcText = atc ? atc.querySelector('.pdp__button-text') : null;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var nOpts = pd.options.length;
  var selected = [];
  for (var s = 0; s < nOpts; s++) selected.push(null);

  var pickers = Array.prototype.slice.call(document.querySelectorAll('.pdp-option-picker[data-option-index]'));
  var byIndex = {};
  var sizeIndex = -1;
  var colorIndex = -1;
  pickers.forEach(function (p) {
    var i = parseInt(p.dataset.optionIndex, 10);
    byIndex[i] = p;
    if (p.dataset.optionKind === 'size') sizeIndex = i;
    if (p.dataset.optionKind === 'color') colorIndex = i;
    p.querySelectorAll('.pdp-option-pill').forEach(function (b) {
      b.dataset.label = (b.getAttribute('aria-label') || '').replace(/ \(sold out\)$/, '');
      if (b.getAttribute('aria-pressed') === 'true') selected[i] = b.dataset.optionValue;
    });
  });

  // Options without a picker (default variant, or unexpected markup): take the rendered variant's value.
  var startVariant = findById(idInput && idInput.value) || pd.variants[0];
  for (var k = 0; k < nOpts; k++) {
    if (!byIndex[k]) selected[k] = startVariant.options[k];
  }

  var busy = false;
  var productSoldOut = !pd.variants.some(function (v) { return v.available; });
  var userChanged = false;
  var orthoProduct = null;
  var orthoVariantId = null;
  var listeners = [];

  /* ---------- helpers ---------- */
  function findById(id) {
    if (!id) return null;
    for (var i = 0; i < pd.variants.length; i++) if (String(pd.variants[i].id) === String(id)) return pd.variants[i];
    return null;
  }
  function matches(v, sel) {
    for (var i = 0; i < nOpts; i++) if (sel[i] != null && sel[i] !== v.options[i]) return false;
    return true;
  }
  function anyAvailable(sel) {
    return pd.variants.some(function (v) { return v.available && matches(v, sel); });
  }
  function currentVariant() {
    for (var i = 0; i < nOpts; i++) if (selected[i] == null) return null;
    for (var j = 0; j < pd.variants.length; j++) if (matches(pd.variants[j], selected)) return pd.variants[j];
    return null;
  }
  function refVariant() {
    return currentVariant() ||
      pd.variants.filter(function (v) { return v.available && matches(v, selected); })[0] ||
      pd.variants.filter(function (v) { return matches(v, selected); })[0] ||
      pd.variants[0];
  }
  function missing() {
    return pickers.filter(function (p) { return selected[parseInt(p.dataset.optionIndex, 10)] == null; });
  }
  function money(cents, trim) {
    var n = cents / 100;
    var whole = trim && Math.round(n * 100) % 100 === 0;
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 }).format(n);
  }
  function setAtcText(t) { if (atcText) atcText.textContent = t; }

  /* ---------- selection ---------- */
  function setPressed(i) {
    var p = byIndex[i];
    if (!p) return;
    p.querySelectorAll('.pdp-option-pill').forEach(function (b) {
      var on = selected[i] != null && b.dataset.optionValue === selected[i];
      b.classList.toggle('pdp-option-pill--selected', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    if (p.dataset.optionKind === 'color') {
      var chosen = p.querySelector('[data-chosen-name]');
      if (chosen) chosen.textContent = selected[i] ? ': ' + selected[i] : '';
    }
  }

  function selectOption(i, value) {
    i = parseInt(i, 10);
    userChanged = true;
    selected[i] = value;
    if (!anyAvailable(selected)) {
      // Keep what was just tapped; drop the conflicting choices (width first).
      var order = ['width', 'size', 'other', 'color'];
      for (var o = 0; o < order.length && !anyAvailable(selected); o++) {
        pickers.forEach(function (p) {
          var j = parseInt(p.dataset.optionIndex, 10);
          if (j === i || p.dataset.optionKind !== order[o] || selected[j] == null) return;
          if (p.querySelectorAll('.pdp-option-pill').length < 2) return;
          if (anyAvailable(selected)) return;
          selected[j] = null;
          setPressed(j);
        });
      }
    }
    setPressed(i);
    clearError(i);
    if (i === colorIndex) updateGallery(refVariant());
    update();
  }

  function refreshAvailability() {
    pickers.forEach(function (p) {
      var i = parseInt(p.dataset.optionIndex, 10);
      p.querySelectorAll('.pdp-option-pill').forEach(function (b) {
        if (b.disabled) return;
        var test = selected.slice();
        test[i] = b.dataset.optionValue;
        var ok = anyAvailable(test);
        b.classList.toggle('pdp-option-pill--unavailable', !ok);
        b.setAttribute('aria-label', b.dataset.label + (ok ? '' : ' (sold out in this combination)'));
      });
    });
  }

  function update() {
    var v = currentVariant();
    var ref = refVariant();

    var priceEl = document.getElementById('pdp-price');
    if (priceEl) {
      var html = '<span class="pdp__price-current">' + money(ref.price) + '</span>';
      if (ref.compare_at_price && ref.compare_at_price > ref.price) html += '<s class="pdp__price-compare">' + money(ref.compare_at_price) + '</s>';
      priceEl.innerHTML = html;
    }
    var inst = document.getElementById('pdp-installment-amount');
    if (inst) inst.textContent = money(Math.floor(ref.price / 4));

    var ship = document.getElementById('pdp-ship-line');
    if (ship && ship.dataset.free) ship.textContent = ref.price >= 7500 ? ship.dataset.free : ship.dataset.under;

    var stock = document.getElementById('pdp-stock-note');
    var soldOut = productSoldOut || (v ? !v.available : false);
    if (atc && !busy) {
      atc.disabled = soldOut;
      setAtcText(soldOut ? 'Sold out' : 'Add to cart · ' + money(ref.price, true));
    }
    if (stock) stock.hidden = !soldOut;

    if (v && idInput) {
      idInput.value = v.id;
      if (userChanged && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState(window.history.state, '', url.toString());
      }
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v }, bubbles: true }));
    }

    refreshAvailability();
    refreshOrtho();
    var state = getState();
    document.dispatchEvent(new CustomEvent('cfw:pdp:state', { detail: state }));
    listeners.forEach(function (fn) { try { fn(state); } catch (e) {} });
  }

  function getState() {
    var v = currentVariant();
    var ref = refVariant();
    var miss = missing();
    return {
      complete: miss.length === 0,
      needs: miss.length ? miss[0].dataset.optionKind : null,
      needsSize: miss.some(function (p) { return p.dataset.optionKind === 'size'; }),
      available: v ? v.available : anyAvailable(selected),
      variantId: v ? v.id : null,
      price: ref.price,
      priceLabel: money(ref.price, true),
      summary: selected.filter(function (x) { return x != null; }).join(' · '),
      image: (ref.featured_media && ref.featured_media.thumb) || pd.featuredImage || ''
    };
  }

  /* ---------- errors ---------- */
  function clearError(i) {
    var p = byIndex[i];
    if (!p) return;
    p.classList.remove('pdp-option-picker--error');
    var slot = p.querySelector('[data-error-slot]');
    if (slot) slot.innerHTML = '';
  }

  function showRequiredError() {
    var p = missing()[0];
    if (!p) return false;
    var kind = p.dataset.optionKind;
    var msg = 'Please choose your size first.';
    if (kind === 'width') msg = 'Please choose your width.';
    else if (kind === 'color') msg = 'Please choose a colour.';
    else if (kind === 'other') msg = 'Please choose a ' + (p.dataset.optionName || 'option').toLowerCase() + '.';
    pickers.forEach(function (q) { clearError(parseInt(q.dataset.optionIndex, 10)); });
    var slot = p.querySelector('[data-error-slot]');
    if (slot) {
      var el = document.createElement('p');
      el.className = 'pdp__size-error';
      el.setAttribute('role', 'alert');
      el.textContent = msg;
      slot.appendChild(el);
    }
    p.classList.add('pdp-option-picker--error');
    p.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    var first = p.querySelector('.pdp-option-pill:not([disabled])');
    if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, reduceMotion ? 0 : 400);
    return true;
  }

  function showAtcError(msg) {
    var slot = document.getElementById('pdp-atc-error-slot');
    if (!slot) return;
    slot.innerHTML = '';
    if (!msg) return;
    var el = document.createElement('p');
    el.className = 'pdp__atc-error';
    el.setAttribute('role', 'alert');
    el.textContent = msg;
    slot.appendChild(el);
  }

  /* ---------- add to cart ---------- */
  function addToCart() {
    if (busy) return Promise.resolve(false);
    if (showRequiredError()) return Promise.resolve(false);
    var v = currentVariant();
    if (!v || !v.available) return Promise.resolve(false);
    showAtcError('');
    busy = true;
    if (atc) atc.setAttribute('aria-busy', 'true');
    setAtcText('Adding…');

    var item = { id: v.id, quantity: 1 };
    var plan = form && form.querySelector('input[name="selling_plan"]:checked');
    if (plan && plan.value) item.selling_plan = parseInt(plan.value, 10);
    var items = [item];
    var orthoBox = document.getElementById('pdp-ortho-addon-input');
    if (orthoBox && orthoBox.checked && orthoVariantId) items.push({ id: orthoVariantId, quantity: 1 });

    var added;
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'Sorry, that did not go into your cart.');
        added = res.j;
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        var list = (added && added.items) || [added];
        document.dispatchEvent(new CustomEvent('cfw:cart:added', { detail: { item: list[0], items: list, cart: cart } }));
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: 'cfw-pdp', data: { source: 'cfw-pdp', itemCount: cart.item_count, productId: pd.productId } }
        }));
        busy = false;
        if (atc) atc.removeAttribute('aria-busy');
        setAtcText('Added ✓');
        setTimeout(update, 2000);
        setTimeout(function () {
          if (!(window.CFW && typeof window.CFW.openCartDrawer === 'function')) window.location.href = root + 'cart';
        }, 300);
        return true;
      })
      .catch(function (err) {
        busy = false;
        if (atc) atc.removeAttribute('aria-busy');
        showAtcError((err && err.message) || 'Sorry, something went wrong. Please try again or call (704) 846-0301.');
        update();
        return false;
      });
  }

  /* ---------- gallery ---------- */
  function mediaIdsForVariant(variant) {
    var media = pd.media || [];
    var ids = [];
    var code = variant.color_code;
    if (code && typeof code === 'object') code = code.value || '';
    code = String(code || '').toLowerCase().trim();
    if (code) {
      var re = new RegExp('(^|[^0-9a-z])' + code.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '([^0-9a-z]|$)');
      media.forEach(function (m) {
        var hay = ((m.alt_text || '') + ' ' + (m.filename || '')).toLowerCase();
        if (re.test(hay)) ids.push(m.id);
      });
    }
    if (!ids.length && colorIndex >= 0 && variant.options[colorIndex]) {
      var name = String(variant.options[colorIndex]).toLowerCase().trim();
      media.forEach(function (m) {
        if ((m.alt_text || '').toLowerCase().indexOf(name) !== -1) ids.push(m.id);
      });
    }
    return ids;
  }

  function setHero(src, alt, mediaId) {
    var hero = document.getElementById('pdp-main-image');
    if (!hero || !src) return;
    var base = src.replace(/([?&])width=\d+/, '$1width=1100');
    hero.srcset = [400, 600, 800, 1100, 1500].map(function (w) { return base.replace('width=1100', 'width=' + w) + ' ' + w + 'w'; }).join(', ');
    hero.src = base;
    hero.alt = alt || '';
    if (mediaId) hero.dataset.mediaId = mediaId;
    var grid = document.getElementById('pdp-media-grid');
    if (grid) grid.querySelectorAll('.pdp-media-grid__item').forEach(function (el) {
      el.classList.toggle('pdp-media-grid__item--active', String(el.dataset.mediaId) === String(mediaId));
    });
  }

  function updateGallery(variant) {
    if (!variant) return;
    var ids = mediaIdsForVariant(variant);
    var fm = variant.featured_media;
    var heroId = fm ? fm.id : (ids[0] || null);
    var grid = document.getElementById('pdp-media-grid');
    if (grid) grid.querySelectorAll('.pdp-media-grid__item').forEach(function (el) {
      var id = parseInt(el.dataset.mediaId, 10);
      el.hidden = ids.length > 1 && ids.indexOf(id) === -1 && !el.classList.contains('pdp-media-grid__item--video');
    });
    if (heroId) {
      var m = (pd.media || []).filter(function (x) { return String(x.id) === String(heroId); })[0];
      if (m) setHero(m.src, m.alt, m.id);
    }
    if (window.mobileGallery) {
      if (window.mobileGallery.filterByMediaIds) window.mobileGallery.filterByMediaIds(ids.length > 1 ? ids : null);
      if (heroId && window.mobileGallery.goToMediaId) window.mobileGallery.goToMediaId(heroId);
    }
  }

  /* ---------- orthotic add-on (contract #4) ---------- */
  function initOrtho() {
    var box = document.getElementById('pdp-ortho-addon');
    if (!box) return;
    var tries = 0;
    (function wait() {
      var C = window.CFW;
      if (C && typeof C.orthoMatch === 'function' && typeof C.orthoPick === 'function') setup(C);
      else if (tries++ < 20) setTimeout(wait, 250);
    })();
    function setup(C) {
      try {
        var products = JSON.parse(document.getElementById('pdp-ortho-products').textContent);
        var match = C.orthoMatch({ arch: 'medium', met: 'no', use: box.dataset.use || 'walking' });
        var picked = C.orthoPick(match, { gender: box.dataset.gender || 'any', products: products });
        var prod = Array.isArray(picked) ? picked[0] : picked;
        if (!prod || !prod.variants) return;
        orthoProduct = prod;
        var price = box.querySelector('[data-ortho-price]');
        if (price) price.textContent = '+' + money(prod.price);
        box.hidden = false;
        refreshOrtho();
      } catch (e) { /* stay hidden */ }
    }
  }

  function refreshOrtho() {
    var box = document.getElementById('pdp-ortho-addon');
    if (!box || !orthoProduct) return;
    var input = document.getElementById('pdp-ortho-addon-input');
    var status = box.querySelector('[data-ortho-status]');
    var size = sizeIndex >= 0 ? selected[sizeIndex] : null;
    orthoVariantId = null;
    if (!size) {
      if (input) input.disabled = false;
      if (status) status.textContent = 'We match the size to your shoe.';
      return;
    }
    var n = parseFloat(String(size).replace(/[^0-9.]/g, ' ').trim().split(' ')[0]);
    var whole = Math.ceil(n);
    var ov = orthoProduct.variants.filter(function (x) { return parseFloat(x.size) === whole; })[0];
    if (ov && ov.available) {
      orthoVariantId = ov.id;
      if (input) input.disabled = false;
      if (status) status.textContent = 'Size ' + whole + ', matched to your shoe.';
    } else {
      if (input) { input.checked = false; input.disabled = true; }
      if (status) status.textContent = 'Not available in size ' + (isNaN(whole) ? size : whole) + '. Call us and we will find one.';
    }
  }

  /* ---------- wiring ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;

    var pill = t.closest('.pdp-option-picker .pdp-option-pill');
    if (pill && !pill.disabled) {
      e.preventDefault();
      selectOption(pill.dataset.optionIndex, pill.dataset.optionValue);
      return;
    }

    var thumb = t.closest('#pdp-media-grid button.pdp-media-grid__item');
    if (thumb) {
      var img = thumb.querySelector('img');
      if (img) setHero(img.dataset.fullSrc || img.src, img.alt, thumb.dataset.mediaId);
      var hero = document.getElementById('pdp-main-image');
      if (hero && hero.getBoundingClientRect().top < 0) hero.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      return;
    }

    var guide = t.closest('[data-open-size-guide]');
    if (guide) {
      var dlg = document.getElementById('pdp-size-guide-dialog');
      if (dlg && dlg.showModal) { e.preventDefault(); dlg.showModal(); }
      return;
    }
    var dlgClose = t.closest('[data-close-size-guide]');
    if (dlgClose || (t.id === 'pdp-size-guide-dialog')) {
      var d = document.getElementById('pdp-size-guide-dialog');
      if (d && d.open) d.close();
      return;
    }

    var widthBtn = t.closest('[data-toggle-width-note]');
    if (widthBtn) {
      var note = document.getElementById('pdp-width-note');
      if (note) {
        var open = note.hidden;
        note.hidden = !open;
        widthBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        queueSticky();
      }
      return;
    }

    var noteBtn = t.closest('.pdp__note-toggle');
    if (noteBtn) {
      var body = document.getElementById(noteBtn.getAttribute('aria-controls'));
      if (body) {
        var isOpen = !body.hidden;
        body.hidden = isOpen;
        noteBtn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        queueSticky();
      }
      return;
    }

    var det = t.closest('[data-open-details]');
    if (det) {
      var target = document.getElementById(det.dataset.openDetails);
      if (target) {
        e.preventDefault();
        if (target.tagName === 'DETAILS') target.open = true;
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        var sum = target.querySelector('summary');
        if (sum) sum.focus({ preventScroll: true });
      }
    }
  });

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      addToCart();
    });
  }

  window.cfwVariantPicker = { selectOption: selectOption, updateGallery: updateGallery };
  window.cfwPdp = {
    getState: getState,
    addToCart: addToCart,
    showRequiredError: showRequiredError,
    onChange: function (fn) { if (typeof fn === 'function') listeners.push(fn); }
  };

  /* Desktop: whichever column is shorter (and fits the window) sticks. */
  function stickyColumns() {
    var media = document.querySelector('.pdp .pdp__media');
    var info = document.querySelector('.pdp .pdp__info');
    if (!media || !info) return;
    media.classList.remove('is-sticky');
    info.classList.remove('is-sticky');
    if (window.innerWidth < 990) return;
    var room = window.innerHeight - 110;
    var mh = media.offsetHeight;
    var ih = info.offsetHeight;
    if (mh < ih && mh <= room) media.classList.add('is-sticky');
    else if (ih < mh && ih <= room) info.classList.add('is-sticky');
  }
  var stickyTimer;
  function queueSticky() { clearTimeout(stickyTimer); stickyTimer = setTimeout(stickyColumns, 150); }
  window.addEventListener('resize', queueSticky);
  window.addEventListener('load', stickyColumns);
  document.addEventListener('cfw:pdp:state', queueSticky);

  initOrtho();
  update();
  stickyColumns();
  if (selected[colorIndex] != null && pd.variants.length > 1) {
    var sv = findById(idInput && idInput.value);
    if (sv && sv.options[colorIndex] === selected[colorIndex]) updateGallery(sv);
  }
})();
